import React, {useEffect, useState} from "react";
import VenuesService from "../../services/venues.service";
import {Alert, Breadcrumb, Button, Card, Col, Form, Row} from "react-bootstrap";
import VenueItem from "./venueItem.component";
import Container from "react-bootstrap/Container";
import AuthService from "../../services/auth.service";
import {GENRES, isLoggedIn, isLoggedInWithRole} from "../../common/utils";
import InputWithIcon from "../../common/input-with-icon";
import {API_EDITS_ALLOWED} from "../../services/axios.utils";

const VenuesList = () => {
    const [search, setSearch] = useState("")
    const [actType, setActType] = useState("")
    const [slot, setSlot] = useState("")
    const [venues, setVenues] = useState([])
    const [venuesCount, setVenuesCount] = useState(0)

    let loggedInPerformer = isLoggedInWithRole('performer');

    let user = AuthService.getCurrentUser();
    let loggedIn = isLoggedIn();
    let editsAllowed = API_EDITS_ALLOWED === "true" || (loggedIn && user.is_admin);

    const fetchVenues = () => {
        VenuesService.getVenues(search, actType, slot).then(
            response => {
                setVenues(response.data.data);
                setVenuesCount(response.data.total)
                console.log("venues:" + JSON.stringify(response.data.data));
            },
            error => {
                console.log(error);
            });
    }

    // load once on mount or on filter changes
    useEffect(() => {
        fetchVenues();
    }, [actType, slot]);  // eslint-disable-line react-hooks/exhaustive-deps

    // fetch venues with search filter after debounce
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            fetchVenues();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [search]);  // eslint-disable-line react-hooks/exhaustive-deps

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleActTypeChange = (e) => {
        setActType(e.target.value);
    };

    const handleSlotChange = (e) => {
        setSlot(e.target.value);
    };

    const anySearch = () => {
        return search !== null || actType !== null || slot !== null;
    }

    // const slotsList = (venue)  => {
    //     venue.available_slots.map((s) => {
    //         return (
    //             <div>
    //                 {s.slot_def}
    //             </div>
    //         )
    //     })
    // }

    return (
        <Container fluid>
            <Row>
                <Col>
                    <h3>
                        <Breadcrumb>
                            <Breadcrumb.Item active>Venues</Breadcrumb.Item>
                        </Breadcrumb>
                    </h3>
                </Col>
                <Col>
                    <div className="float-end">
                        {(user !== null && (user.is_host || user.is_admin)) &&
                            <Button href="/venues/new" disabled={!editsAllowed}>New Venue</Button>
                        }
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            {loggedInPerformer &&
                            <Alert variant="primary">
                                {/*<div>Here are the venues that have registered so far.</div>*/}
                                <div>
                                    If you're an act looking for a venue that can host you,
                                    use the search fields below to find venues based on street name, description,
                                    preferred genre, and slot availability. Once you find a venue you like, click on
                                    it and fill out the contact form at the bottom to let the owner know you are
                                    interested in a match.
                                </div>
                            </Alert>
                            }
                            <Container style={{paddingLeft: "0px", paddingRight: "0px"}}>
                                <Row className="mb-3">
                                    <Col>Found {venuesCount} results</Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col>
                                        <InputWithIcon
                                            type="text"
                                            value={search}
                                            placeholder="Search street name or description"
                                            onChange={handleSearchChange}
                                            icon="bi-search"
                                        />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col xs={2}>
                                        Filter
                                    </Col>
                                    <Col xs={5}>
                                        <Form.Select onChange={handleActTypeChange}>
                                            <option value="">Any Genre</option>
                                            {GENRES.map((g, index) => (
                                                <option key={index} value={g.value}>{g.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col xs={5}>
                                        <Form.Select onChange={handleSlotChange}>
                                            <option value="">Any Slot Availability</option>
                                            <option value="Slot 1:true">Slot 1 Available</option>
                                            <option value="Slot 2:true">Slot 2 Available</option>
                                            <option value="Slot 3:true">Slot 3 Available</option>
                                            <option value="Slot 4:true">Slot 4 Available</option>
                                            {/*<option value="Slot 4:false">Slot 4 Unavailable</option>*/}
                                        </Form.Select>
                                    </Col>
                                </Row>
                            </Container>
                        </Card.Body>
                    </Card>

                    {venues.length === 0 && anySearch() &&
                        <>
                            There are no venues that match your search criteria.
                        </>
                    }
                    {venues.length === 0 && !anySearch() &&
                        <>
                            There are no registered venues yet. Please check again later.
                        </>
                    }
                    {venues.length > 0 &&
                        venues.map((venue) =>
                            <VenueItem key={venue.id} venue={venue}/>
                        )
                    }

                </Col>
            </Row>
        </Container>
    );
}

export default VenuesList;
